import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {StoreService} from "../../services/StoreService";
import {Retailer, Store, StoreListingAvailability} from "../../model/Store";
import {AuthService} from "../../services/AuthService";
import {OperationService} from "../../services/OperationService";
import {Operation} from "../../model/Operation";
import {apiconfig} from "../../app/api.config";
import {OrderInfo} from "../nav/OrderInfo";
import {OrderEditPage} from "../order-edit/order-edit";
import {ActivityDate, ActivityWeek, DateService} from "../../services/DateService";

/**
 * Generated class for the StartOrderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-start-order',
  templateUrl: 'start-order.html',
})
export class StartOrderPage {

  public iconsURL: string = apiconfig.LOGA_ICONS;


  // contextual information to create the next order
  orderInfo: OrderInfo;


  //stores loaded from the api
  private stores: Store[];

  //operations loaded from the api
  private operations: Operation[];

  // -- helper to show / hide the picker in a logical order
  uiShowStorePicker: boolean;
  uiShowOperationPicker: boolean;

  // -- spinners
  uiLoadingOperations: any;
  uiLoadingStore: any;

  searchXp: string;

  uiSelectedOperation: Operation;
  uiSelectedStore: Store;
  uiShowCreateBtn: any;

  uiDisplayDateStr: string;

  private currentWeek: ActivityWeek;


  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public storeService: StoreService,
              public operationService: OperationService,
              public dateService: DateService,
              public authService: AuthService) {
  }

  ionViewDidLoad() {
  }

  ionViewDidEnter() {

    this.orderInfo = new OrderInfo();

    if (!this.currentWeek)
      this.currentWeek = this.dateService.getCurrentWeek();

    this.orderInfo.operation.id = this.navParams.data['operationId'];
    this.orderInfo.operation.name = this.navParams.data['operationName'];

    let defaultActivityLogaDay: number = this.navParams.data['defaultDate'];
    if (defaultActivityLogaDay != null) {
      this.orderInfo.defaultDate = defaultActivityLogaDay;
      this.uiDisplayDateStr = new ActivityDate().withTimeStamp(defaultActivityLogaDay).computeShortLabel();
    }

    this.orderInfo.dailyTourPlanning = this.navParams.data['tourIdentifier'];
    this.orderInfo.tourPlanningDay = this.navParams.data['tourDay'];
    this.orderInfo.previousOrderInTour = this.navParams.data['previousOrderInTour'];

    this.uiShowStorePicker = false;
    this.uiShowOperationPicker = true;
    this.uiShowCreateBtn = false;
    this.uiLoadingOperations = true;
    this.uiLoadingStore = false;

    this.operationService.loadOperationsWithQuota(true, true)
      .then(response => {
        this.operations = response;
        this.uiLoadingOperations = false;

        if (this.operations != null && this.orderInfo.operation.id != null) {
          for (let i = 0; i < this.operations.length; i++) {
            let op = this.operations[i];
            if (op.id === this.orderInfo.operation.id) {
              this.onSelectOperation(i);
              break;
            }
          }
        } else if (this.operations.length == 1) {
          //if we have only one operation, let's pick the first one
          this.onSelectOperation(0);
        }
      });
  }

  onSelectStore(i: number) {
    if (i >= 0) {
      this.uiSelectedStore = this.stores[i];
      this.orderInfo.store = this.stores[i];
    } else {
      this.uiSelectedStore = null;
      this.orderInfo.store = null;
    }
    this.processVisibility();
    this.createIfAllSet();
  }

  onSelectOperation(i: number) {
    if (i >= 0) {
      this.uiSelectedOperation = this.operations[i];
      this.orderInfo.operation.id = this.operations[i].id;
      this.orderInfo.operation.name = this.operations[i].name;
    } else {
      this.uiSelectedOperation = null;
      this.orderInfo.operation.id = null;
      this.orderInfo.operation.name = null;
    }


    this.reloadStores();

    this.processVisibility();
  }


  private reloadStores() {
    console.log('reload-stores')
    this.storeService.loadRetailers().then(retailers => {

      this.storeService.searchStores(this.authService.loggedUser.id, "", "", this.orderInfo.operation.id, this.currentWeek == null ? null : this.currentWeek.getStartDatetamp()).then((stores) => {
        this.stores = stores;

        console.log("Number of store loaded : " + this.stores.length);
        for (let i = 0; i < this.stores.length; i++) {

          let ret = retailers.filter((myretailer) => {
              return myretailer.id === this.stores[i].retailer;
            }
          );

          if (ret && ret.length > 0) {
            this.stores[i].uiRetailer = new Retailer();
            this.stores[i].uiRetailer.id = ret[0].id;
            this.stores[i].uiRetailer.name = ret[0].name;
            this.stores[i].uiRetailer.code = ret[0].code;
          }

          // -- we don't want to display too many stores
          if (i > 200) {
            this.stores[i].uiShouldBeHidden = true;
          }

          if (this.orderInfo != null && this.orderInfo.store != null && this.orderInfo.store.id === this.stores[i].id) {
            this.uiSelectedStore = this.stores[i];
          }
        }

        this.uiLoadingStore = false;

        this.processVisibility();

      }).catch(err => {
        console.log('Could not load Stores - Api issue ?')
        console.log(err);
      });
    });
  }


  createOrder() {
    this.orderInfo.store = this.uiSelectedStore;
    this.navCtrl.pop().then(any => {
      return this.navCtrl.push(OrderEditPage, {orderInfo: this.orderInfo});
    })
  }

  private createIfAllSet() {
    if (this.orderInfo.operation != null && this.orderInfo.operation.id != null && this.uiSelectedStore != null)
      this.createOrder();
  }

  private processVisibility() {
    this.uiShowOperationPicker = this.orderInfo.operation.id == null;
    this.uiShowStorePicker = !this.uiShowOperationPicker && (this.orderInfo.store == null || this.orderInfo.store.id == null);
    this.uiShowCreateBtn = this.orderInfo.operation.id != null && this.orderInfo.store != null && this.orderInfo.store.id != null;
  }

  searchXpCallback($event: UIEvent) {

    this.uiLoadingStore = true;

    if (this.searchXp == null || this.searchXp.length <= 1) {
      //if we have no filter, then just show the 200 first entries
      for (let i = 0; i < this.stores.length; i++) {
        this.stores[i].uiShouldBeHidden = i > 200;
      }
      this.uiLoadingStore = false;
      return;
    }

    var rxp = new RegExp(this.searchXp, 'i');
    if (this.stores != null)
      for (let itm of this.stores) {

        var hideMe = this.searchXp != null && this.searchXp.length > 0;

        if (hideMe && itm.name.search(rxp) >= 0)
          hideMe = false;

        if (hideMe && itm.address != null && itm.address.city != null && itm.address.city.search(rxp) >= 0)
          hideMe = false;

        if (hideMe && itm.address != null && itm.address.line1 != null && itm.address.line1.search(rxp) >= 0)
          hideMe = false;

        if (hideMe && itm.address != null && itm.address.line2 != null && itm.address.line2.search(rxp) >= 0)
          hideMe = false;


        if (hideMe && itm.address != null && itm.address.zipCode != null && itm.address.zipCode.search(rxp) >= 0)
          hideMe = false;

        if (hideMe && itm.address != null && itm.address.administrativeArea != null && itm.address.administrativeArea.search(rxp) >= 0)
          hideMe = false;

        if (hideMe && itm.address != null) {
          if (itm.address.administrativeArea != null && itm.address.zipCode != null) {
            let cp = itm.address.administrativeArea + itm.address.zipCode;
            if (cp.search(rxp) >= 0)
              hideMe = false;
          }
        }

        if (hideMe && itm.uiRetailer != null && itm.uiRetailer.code != null && itm.uiRetailer.code.search(rxp) >= 0)
          hideMe = false;

        if (hideMe && itm.uiRetailer != null && itm.uiRetailer.name != null && itm.uiRetailer.name.search(rxp) >= 0)
          hideMe = false;

        if (hideMe && itm.clientCode != null && itm.clientCode.search(rxp) > 0)
          hideMe = false;

        itm.uiShouldBeHidden = hideMe;
      }

    this.uiLoadingStore = false;
  }

  computePlanningPreviewStyle(stav: StoreListingAvailability) {
    if (stav.alreadyPlanned)
      return "plan-preview plan-preview-already"
    else if (stav.openForPlanning)
      return "plan-preview plan-preview-open-planning"
    else
      return "plan-preview plan-preview-close-planning"
  }

  nextWeek() {
    this.currentWeek.addWeek();
    this.stores = null;
    this.reloadStores();
  }

  previousWeek() {
    this.currentWeek.removeWeek();
    this.stores = null;
    this.reloadStores();
  }


}



// WEBPACK FOOTER //
// ./src/pages/start-order/start-order.ts